import { apollo } from './graphql';
import { GET_FRONTEND_VERSION } from './queries/version';
import version from '../../build.json';

export const buildInfo: { build: string; lastUpdatedAt: string; buildShort: string } = {
  ...version,
  buildShort: (version.build as string).substring(0, 6),
};

export async function getFrontendVersion(): Promise<{ outdated: boolean; lastUpdatedAt: Date }> {
  const result = await apollo.query({
    query: GET_FRONTEND_VERSION,
  });

  const serverBuild = result.data.frontend.build;
  return {
    outdated: serverBuild !== buildInfo.build,
    lastUpdatedAt: new Date(result.data.frontend.lastUpdatedAt),
  };
}
